import { render } from "./TheLoaiDen.vue?vue&type=template&id=7360bd8a"
import script from "./TheLoaiDen.vue?vue&type=script&lang=js"
export * from "./TheLoaiDen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__